import FJBase from './style/FJBase';
import FJTextStyle from './FJTextStyle';

class FJTextStyleNone extends FJTextStyle {
    initStyles(props = {}) {
        let base = new FJBase({
            ...props,
            offset: 0,
            angle: 0,
            position: 'relative',
        });

        this._styles = [base];
    }
}

export default FJTextStyleNone;
